import { Item } from '@/models';

export class AssetLookup {
  private byIdMap: Map<string, Item> = new Map();
  private byStreamingEngineClipIdMap: Map<string, Item> = new Map();

  constructor(private assets: Item[]) {
    for (const asset of assets) {
      this.byIdMap.set(asset.id, asset);
      // this.byStreamingEngineClipIdMap.set(asset.streamingEngineClipId, asset);
    }
  }

  add(asset: Item) {
    this.byIdMap.set(asset.id, asset);
    // this.byStreamingEngineClipIdMap.set(asset.streamingEngineClipId, asset);
  }

  /**
   * This is like get by Id, but smarter...
   * @param id
   * @returns
   */
  smartGetById(id: string): Item {
    const byIdMap = this.byIdMap;
    const byStreamingEngineClipIdMap = this.byStreamingEngineClipIdMap;
    let asset = this.byIdMap.get(id);
    // if (asset == null) {
    //   asset = this.byStreamingEngineClipIdMap.get(id);
    // }
    if (asset == null) {
      console.error(`[smartGetById] Unexpected, couldn't find asset in lookup, asset id: ${id}`);
    }
    return asset;
  }
}
